import {Controller} from "@hotwired/stimulus";
import {useHover} from "stimulus-use";

export default class extends Controller {
  static values = {
    className: {type: String, default: "mouseHover"}
  }

  connect() {
    useHover(this, {element: this.element});
  }

  mouseEnter() {
    this.element.classList.add(this.classNameValue);
  }

  mouseLeave() {
    this.element.classList.remove(this.classNameValue);
  }
}
